import { Button } from "../Button";
import type { Audience } from "@/content/audiences";

export function AudienceClosing({ audience: a }: { audience: Audience }) {
  return (
    <section className="py-20 md:py-28">
      <div className="container-wide">
        <div className="mx-auto max-w-4xl rounded-[2rem] border border-white/10 bg-gradient-to-br from-surface to-background p-10 text-center md:p-14">
          <div className="text-xs uppercase tracking-[0.18em] text-mint">Nästa steg</div>
          <h2 className="mt-3 text-balance text-3xl font-semibold leading-tight md:text-5xl">
            30 minuter räcker för att se om vi passar er.
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-pretty text-base text-muted-foreground md:text-lg">
            Vi går igenom var ni är, vad ni behöver, och om {a.recommend} faktiskt
            är rätt för er fas. Säger ni nej är vi inte sura.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Button
              to="/kontakt"
              variant="peach"
              arrow
              trackId="book_strategy_meeting"
              trackProps={{ location: `audience_${a.slug}_closing`, audience_slug: a.slug }}
            >
              Boka strategimöte
            </Button>
            <Button
              to="/priser"
              variant="outline"
              trackId="view_pricing"
              trackProps={{ location: `audience_${a.slug}_closing`, audience_slug: a.slug }}
            >
              Se priser
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
